<template>
  <v-data-table :headers="headers" :items="data" class="elevation-0">
    <template v-slot:[`item.plan`]="{ item }">
      {{ getplan(item.plan) }}
    </template>
    <template v-slot:[`item.payment`]="{ item }">
      {{ item.payment }} $
    </template>
    <template v-slot:[`item.finished_at`]="{ item }">
      {{ $subStringDate(item.finished_at) }}
    </template>
    <template v-slot:[`item.created_at`]="{ item }">
      {{ $subStringDate(item.created_at) }}
    </template>
    <template v-slot:[`item.contract_link`]="{ item }">
      <v-btn
        text
        :disabled="item.contract_link == null ? true : false"
        color="green"
        :href="item.contract_link"
        target="blank"
        >Contract PDF<v-icon class="ml-2">mdi-download</v-icon></v-btn
      >
    </template>
    <template v-slot:[`item.invoice_pdf`]="{ item }">
      <v-btn
        text
        :disabled="item.invoice_pdf == null ? true : false"
        color="green"
        :href="item.invoice_pdf"
        target="blank"
        >Invoice PDF<v-icon class="ml-2">mdi-download</v-icon></v-btn
      >
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "TablePayments",
  props: ["data"],

  data() {
    return {
      headers: [
        {
          text: "#ID",
          align: "center",
          sortable: true,
          value: "id",
        },
        { text: "Plan", value: "plan" },
        { text: "Contract code", value: "unid" },
        { text: "Payment", value: "payment" },
        { text: "Methods", value: "methods" },
        { text: "ID Payments", value: "id_payment" },
        { text: "Finished at", value: "finished_at" },
        { text: "Created at", value: "created_at" },
        { text: "Download invoice", value: "invoice_pdf" },
        { text: "Download contract", value: "contract_link" },
      ],
    };
  },

  methods: {
    getplan(no) {
      if (no == 0) {
        return "Trial";
      } else if (no === 1) {
        return "Starter";
      } else if (no === 2) {
        return "Professional";
      } else return "Businesses";
    },
  },
};
</script>
